export default {"src":"/_next/static/media/aura-profile.bed3e17e.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};